// This file is auto-generated by the generate:translations task. Do not edit directly.
import { GeneralKey } from '../../types/general';

const GeneralStrings: Partial<Record<GeneralKey, string>> = {
  add: 'Hinzuf\u00FCgen',
  saveData: 'Speichern',
  generic: 'Generikum',
  select: 'Ausw\u00E4hlen',
  remove: 'Entfernen',
  edit: 'Bearbeiten',
  yes: 'Ja',
  no: 'Nein',
  next: 'Weiter',
  back: 'Zur\u00FCck',
  understood: 'Verstanden',
  confirm: 'Best\u00E4tigen',
  notNow: 'Jetzt nicht',
  mediPlus: 'Medi+',
  option: 'Optionen',
  or: 'oder',
  the: 'der',
  errorTryAgain: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
  'notifications.changesSaved': '\u00C4nderungen gespeichert',
  sortDateAsc: 'Datum: \u00C4lteste zuerst',
  sortDateDesc: 'Datum: Neue zuerst',
  sortTitleAsc: 'Name: A-Z',
  sortTitleDesc: 'Name: Z-A',
  originalMedicament: 'Originalmedikament',
  originalMedicaments: 'Originalmedikamente',
  status: 'Status',
  telephone: 'Telefon:',
  goToSettings: 'Zu den Einstellungen',
  goToDashboard: 'Zur\u00FCck zum Dashboard',
  genericError: 'Es ist ein Fehler aufgetreten',
  healthInfo: 'Gesundheitsangaben',
  changeInfo: 'Angaben \u00E4ndern',
  lastChecked: 'Zuletzt gepr\u00FCft',
  congratulation: 'Gratulation.',
  'notifications.newEmail_loginHint':
    'Bitte geben Sie ihr Passwort ein, um die \u00C4nderung der E-Mail-Adresse abzuschliessen.',
  'notifications.newEmail_success': 'E-Mail-Adresse erfolgreich best\u00E4tigt.',
  'notifications.registerConfirmation_success':
    'Sie haben die Registrierung erfolgreich abgeschlossen. Sie k\u00F6nnen sich nun einloggen.',
  'notifications.errorConfirmTermsAndPrivacy':
    'Bitte best\u00E4tigen Sie die Datenschutzbestimmungen und Nutzungsbedingungen.',
  'notifications.registerConfirmation_tokenExpired':
    'Ihr Registrierung-Link ist abgelaufen. Bitte f\u00FChren Sie die Registrierung erneut durch.',
  'notifications.accountActivated': 'Sie haben ihr Benutzerprofil erfolgreich aktiviert',
  'notifications.deactivate_successMedidossier': 'Sie haben ihr Kunden-Konto erfolgreich deaktiviert',
  'notifications.permissionDeniedHeadline': 'Keine Berechtigung',
  'notifications.permissionDeniedText':
    'Als impersonierter Benutzer haben Sie keine Berechtigung Kundendaten zu bearbeiten.',
  'notifications.automaticLogout':
    'Sie wurden aus Sicherheitsgr\u00FCnden wegen Inaktivit\u00E4t abgemeldet. Bitte melden Sie sich erneut an.',
  'notifications.publicPrices':
    '* Die angegebenen Preise entsprechen dem festgelegten Publikumspreis f\u00FCr Medikamente auf der Spezialit\u00E4tenliste inkl. MwSt oder f\u00FCr alle anderen Produkte dem von Zur Rose berechneten Preis inkl. Mwst (z.B. f\u00FCr Produkte welche nicht auf der Spezialit\u00E4tenliste stehen). Allf\u00E4llige Rabatte (z.B. Versicherungs-Rabatte) oder Taxen (z.B. pharmazeutische Checks) sind noch nicht ber\u00FCcksichtigt und werden auf Ihrem Lieferschein ausgewiesen.',
  'notifications.sessionInvalidText':
    'Diese Benutzersitzung wurde durch eine Neuanmeldung oder eine Abmeldung in einem anderen Browserfenster beendet.',
  reloadPage: 'Seite neu laden',
  'addressType.deliveryAddress': 'Lieferadresse',
  'addressType.domicilAddress': 'Domiziladresse',
  genericMedicamentSubstitutionAllowedHint:
    'Sie haben in den Profileinstellungen zugestimmt, dass Original-Medikamente durch Generika ersetzt werden d\u00FCrfen. Aufgrund Ihrer getroffenen Auswahl liefern wir Ihnen anstelle des Original-Medikamentes wenn m\u00F6glich ein g\u00FCnstigeres Generikum.',
  confirmTermsAndPrivacy: 'Ich akzeptiere die {0}Datenschutzerkl\u00E4rung{1} und {2}Nutzungsbedingungen{1}',
  btnAcceptAGB: 'Ok',
  confirmAGB:
    ' Ich best\u00E4tige, dass ich die {0}Allgemeinen Gesch\u00E4ftsbedingungen{1} gelesen habe und erkl\u00E4re mich mit ihnen einverstanden.',
  'notifications.errorConfirmAGB':
    'Akzeptieren Sie die Allgemeinen Gesch\u00E4ftsbedingungen um Ihre Bestellung aufgeben zu k\u00F6nnen.',
  newsletterOverlayContent:
    '<1>Ihr zurrose.ch-Newsletter</1><2>Abonnieren Sie den Newsletter von Zur Rose!</2><3>Im Newsletter informieren wir Sie regelm\u00E4ssig \u00FCber neue Services, Produkte, spezielle Angebote, Gutscheinaktionen und Gesundheitsthemen.</3><4><5>Newsletter abonnieren und profitieren:</5></4>',
  newsletterBenefit1: 'Informationen zu den bequemen digitalen Services der Zur Rose Online-Apotheke ',
  newsletterBenefit2: 'Weitere exklusive Informationen im Bereich der Zur Rose Online-Apotheke',
  newsletterBenefit3:
    'Vorstellung von Produkten im Zur Rose Online-Shop (zurrose-shop.ch) mit attraktiven Angeboten und Rabatten ',
  newsletterBenefit4: 'Spannende Informationen und Angebote unserer Kooperationspartner',
  newsletterOverlayChoose:
    'M\u00F6chten Sie k\u00FCnftig von den Vorteilen des Zur Rose Newsletters profitieren und diesen abonnieren?',
  newsletterOverlayFootnote:
    '\u00DCbrigens: Sie k\u00F6nnen den Newsletter jederzeit durch einen Link im Newsletter wieder abbestellen.',
  cancel: 'Abbrechen',
  backToDashboard: 'Zur\u00FCck zur Startseite',
  backToOverview: 'Zur\u00FCck zur \u00DCbersicht',
  zurroseEmail: '<1>team@zurrose.ch</1>',
  close: 'Schliessen',
  none: 'Keine',
  confirmAndSave: 'Best\u00E4tigen und speichern',
  weight: 'Gewicht',
  size: 'K\u00F6rpergr\u00F6sse',
  dateOfBirth: 'Erwartetes Geburtsdatum',
  setUp: 'Einrichten',
  help: 'Hilfe',
  username: 'Benutzername',
  change: '\u00C4ndern',
  'salutation.1': 'Herr',
  'salutation.2': 'Frau',
  'title.1': 'Prof.',
  'title.2': 'Prof. Dr.',
  'title.3': 'Prof. Dr. med.',
  'title.4': 'Dr.',
  'title.5': 'Dr. med.',
  'title.6': 'Sr.',
  reset: 'Zur\u00FCcksetzen',
  expired: 'Abgelaufen',
  exhausted: 'Ausgesch\u00F6pft',
  'notifications.newEmail_tokenExpired':
    'Ihr E-Mail-Best\u00E4tigungs-Link ist abgelaufen. Ihre neue E-Mail-Adresse wurde nicht gespeichert. Sollten Sie weiterhin eine neue E-Mail-Adresse angeben wollen, \u00E4ndern Sie diese bitte erneut.',
  'notifications.newEmail_tokenRedeemed': 'Sie haben Ihre E-Mail-Adresse bereits ge\u00E4ndert.',
  customerId: 'Kundennummer',
  noFilterMatches: 'Es konnten keine Eintr\u00E4ge zu Ihren aktuellen Filtereinstellungen gefunden werden',
  noNewMessages: 'Derzeit liegen keine neuen Benachrichtigungen f\u00FCr Sie vor.',
  generalContactText:
    'Haben Sie weitere Fragen? Wir helfen Ihnen gerne weiter. Kontaktieren Sie unseren Kundendienst unter der Nummer <1>0800 711 222</1> (Mo.-Do. 7:30 - 18 Uhr, Fr. 7:30 - 17:30).',
  gotToProfile: 'Zum Profil',
  ok: 'OK',
  dontShowAgain: 'Diesen Hinweis nicht mehr anzeigen',
  info: 'Info',
  confirmAndContinue: 'Best\u00E4tigen und Weiter',
  saveAndContinue: 'Speichern und Weiter',
  storno: 'stornieren',
  delivery: 'Lieferung',
  box: 'Packung',
  boxes: 'Packungen',
  getsOrderedAt: 'Wird bestellt am:',
  deliveryToHomeAddress: 'Versand an angegebene Domiziladresse',
  deliveryToDeliveryAddress: 'Versand an angegebene Lieferadresse',
  shippingLabel: 'Versandetikett',
  validUntil: 'Zu beziehen bis:',
  remaining: 'Restmenge:',
  asNeeded: 'nach Bedarf',
  dosage: 'Dosierung:',
  PdfGenerationPleaseWait: 'Ihr Dokument wird erstellt. Bitte warten Sie einen Moment.',
  'notifications.expiresSoonWithDetails': 'Ihr Rezept l\u00E4uft in {0} am {1} ab.',
  'notifications.coolingMedicine': 'K\u00FChlpflichtiges Medikament',
  'notifications.expiresSoon': 'Ihr Rezept l\u00E4uft demn\u00E4chst ab!',
  'notifications.tooltipExpiresSoon':
    'Ihr Rezept l\u00E4uft demn\u00E4chst ab. Bitte kontaktieren Sie Ihren Arzt, um ein neues Rezept zu erhalten.',
  medicationsWithSelectableDeliverySlot: 'Medikamente mit w\u00E4hlbarer Zustellzeit',
  selectableDeliverySlotConditions:
    'Wenn Sie 3 Packungen bestellen, k\u00F6nnen Sie kostenlos ein Zeitfenster f\u00FCr den Liefertermin w\u00E4hlen.',
  recipeInfo: 'Rezept',
  doctor: 'Arzt:',
  of: 'von',
  selectADate: 'Datum ausw\u00E4hlen',
  'daysString.1': 'Tag',
  'daysString.2': 'Tage',
  savePersonalData: 'Pers\u00F6nliche Daten speichern?',
  dontsaveData: 'Nicht speichern',
  pickPostOpeningHours24h: '24h ge\u00F6ffnet',
  'shortDay.monday': 'Mo',
  'shortDay.tuesday': 'Di',
  'shortDay.wednesday': 'Mi',
  'shortDay.thursday': 'Do',
  'shortDay.friday': 'Fr',
  'shortDay.saturday': 'Sa',
  'shortDay.sunday': 'So',
  oClock: 'Uhr',
  viewOpeningTimes: '\u00D6ffnungszeiten anzeigen',
  completeData: 'Daten vervollst\u00E4ndigen',
  'notifications.mergeCustomerText':
    'Sind Sie bereits Zur Rose-Kundin oder Kunde und haben schon einmal Medikamente von uns erhalten, aber es fehlen Ihre Rezepte und letzten Bestellungen in Ihrem Profil? Dann k\u00F6nnen Sie eine Verbindung Ihrer Daten mit Ihrem Kunden-Konto beantragen.',
  'notifications.mergeCustomerYes': 'Ja, Zusammenf\u00FChrung beantragen',
  'notifications.mergeCustomerNo': 'Nein, ich bestelle zum ersten Mal',
  'wegovy.title': 'Wegovy',
  substitution: 'Substitution',
  goToOrder: 'Zur Bestellung',
  revert: 'R\u00FCckg\u00E4ngig',
  reverted: 'R\u00FCckg\u00E4ngig gemacht',
  now: 'Jetzt',
  hideDetails: 'Details ausblenden',
  statusActive: 'aktiviert',
  statusInactive: 'deaktiviert',
  pageTitleWelcomePage: 'Ihr pers\u00F6nliches Kunden-Konto | Zur Rose',
  pageTitleWelcomePageMediplus: 'Medi+ | Zur Rose',
  'metaTags.description.loginPage':
    'Im Zur Rose Kunden-Konto anmelden: in Ihrem pers\u00F6nlichen Bereich finden Sie \u2713 Rezept- und Medikamenten-\u00DCbersicht \u2713 Aktuellen Status Ihrer Bestellungen \u2713 Neuigkeiten',
  'metaTags.description.welcome':
    'Willkommen beim Kunden-Konto von Zur Rose \u2713 Rezepte und Medikamenten-Einnahmen verwalten \u2713 Medikamente online nachbestellen \u2713 bequem nach Hause liefern lassen',
  'notification.showMore': 'Mehr anzeigen',
};

export default GeneralStrings;
